<template>
    <div class="right">
        <div class="head">筛选</div>
        <el-form :model="form" status-icon  :rules="rules" ref="form" label-width="100px" class="form-item">
            <p class="tit">分类选择>></p>
            <el-form-item label="商行" prop="firmCode" >
                <el-select v-model="form.firmCode" clearable filterable placeholder="请选择"  @change="change('firmCode','bigCategoryOptions','bigCategoryCode')">
                    <el-option
                        v-for="item in getSelectOptions.firmOptions"
                        :key="item.code"
                        :label="`${item.code} ${item.name}`"
                        :value="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="大类" prop="bigCategoryCode">
                <el-select v-model="form.bigCategoryCode" clearable filterable placeholder="请选择" @change="change('bigCategoryCode','midCategoryOptions','midCategoryCode')">
                    <el-option
                        v-for="item in getSelectOptions.bigCategoryOptions"
                        :key="item.code"
                        :label="`${item.code} ${item.name}`"
                        :value="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="中类" prop="midCategoryCode">
                <el-select v-model="form.midCategoryCode" clearable filterable placeholder="请选择" @change="change('midCategoryCode','smallCategoryOptions','smallCategoryCode')">
                    <el-option
                        v-for="item in getSelectOptions.midCategoryOptions"
                        :key="item.code"
                        :label="`${item.code} ${item.name}`"
                        :value="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="小类" prop="smallCategoryCode" >
                <el-select v-model="form.smallCategoryCode" clearable filterable placeholder="请选择">
                    <el-option
                        v-for="item in getSelectOptions.smallCategoryOptions"
                        :key="item.code"
                        :label="`${item.code} ${item.name}`"
                        :value="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="品项" prop="breedName">
                <el-input  v-model="form.breedName" autocomplete="off" placeholder="请输入品项"></el-input>
            </el-form-item>
            <p class="tit">产区选择>></p>
            <el-form-item label="国家" prop="country">
                <el-select v-model="form.country" clearable placeholder="请选择">
                    <el-option
                        v-for="item in getSelectOptions.countryOptions"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="省份" prop="province" v-if="form.country === 'CN' ">
                <el-select v-model="form.province" filterable multiple clearable placeholder="请选择" @change="handelChangeProvince">
                    <el-option
                        v-for="item in provinceOptions"
                        :key="item.code"
                        :label="item.name"
                        :value="`${item.code} ${item.name}`">
                    </el-option>
                </el-select>
            </el-form-item>
            <p class="tit">上市时间选择>></p>
            <el-form-item label="产地上市时间" prop="date">
                <el-date-picker
                    v-model="form.date"
                    popper-class="date"
                    type="monthrange"
                    format="MM"
                    range-separator="至"
                    start-placeholder="开始月份"
                    end-placeholder="结束月份">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button @click="resetForm('form')">重置</el-button>
                <el-button type="primary" @click="submitForm('form')">查询</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form:{             // 表单数值
                    firmCode: '',
                    bigCategoryCode: '',
                    midCategoryCode: '',
                    smallCategoryCode: '',
                    breedName:'',
                    date:'',
                    province:['00 全部'],
                    country:'CN',
                },
                getSelectOptions:{},
                provinceOptions:[],
                rules: {
                    smallCategoryCode: [
                        {required: true, message: '请选择小类', trigger: 'change'},
                    ],
                    country: [
                        {required: true, message: '请选择国家', trigger: 'change'},
                    ],
                    province: [
                        {required: true, message: '请选择省份', trigger: 'change'},
                    ],
                }
            }
        },
         created(){
             this.getAll()
        },
        methods: {
            /**
             * 获取所有下拉框选项
             * @author Ren YuLei 2020/11/12
             */
            async getAll(){
                let data =  await this.ajax.doPost({
                    packageName: "product",
                    className: "freshOriginInfo",
                    methodName: "getSelectOptions",
                });
                let provinceOptions = data.provinceOptions || []
                provinceOptions.unshift({code:'00', name: '全部'})
                this.getSelectOptions = data
                this.provinceOptions = provinceOptions
            },
            /**
             * 重置
             * @author Ren YuLei 2020/10/30
             */
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            /**
             * 查询
             * @author Ren YuLei 2020/10/30
             */
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$emit('submitForm',this.form)
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 类别联动
             * @author Ren YuLei 2020/11/12
             */
             async change(type,option,flg){
                const {form} = this
                if(form[type]){
                    let data =  await this.ajax.doPost({
                        packageName: "product",
                        className: "freshOriginInfo",
                        methodName: "getCategory",
                        params:{
                            [type]: form[type]
                        }
                    });
                    this.getSelectOptions[option] = data
                     this.form[flg] = ''
                }else {
                  this.getAll()
                }
            },
            /**
             *
             * @author Ren YuLei 2020/10/30
             */
            handelChangeProvince(value){
                const len = value.length
                if(value.findIndex(item=>item ==='00 全部') === len-1 && len ){
                    this.form.province = ['00 全部']
                }
                if(value.findIndex(item=>item ==='00 全部') === 0 && len>1){
                    this.form.province= value.filter(item => item !== '00 全部')
                }
            }
        },
        watch:{
            form:{
                handler(val, oldVal){
                   this.rules.smallCategoryCode[0].required = val.province.join(',') === '00 全部'
                },
                deep:true //true 深度监听
            },
        }
    }
</script>
<style lang="scss">
     .right {
        display: inline-block;
        width: 360px;
        vertical-align: top;
        .head {
            font-size: 20px;
            font-weight: 500;
            color: rgba(27, 153, 79, 1);
            text-align: center;

            height: 55px;
            line-height: 55px;

            border-bottom: 1px solid #eee;
        }
        .tit{
            color: rgba(27, 153, 79, 1);
        }
        .form-item{
            .el-input,.el-date-editor{
                width: 217px;
            }
        }
    }
    .date{
        .el-date-range-picker__header{
            display: none;
        }
    }
</style>